import Style from "./SuppliersTableStyle";
import Spinner from "../../shared/Spinner/Spinner";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";
import api from "../../services/api";

import { FaRegCheckCircle, FaRegCircle } from "react-icons/fa";
import { useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle";

export default function Suppliers(props) {

  const [loading, setLoading] = useState(false);
  const [addingSupplierToSuppliersList, setAddingSupplierToSuppliersList] = useState(false);

  const [supplierToAddToSupplierList, setSupplierToAddToSupplierList] = useState<any>();
  const [suppliers, setSuppliers] = useState<any[]>();

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    setLoading(true);
    GetSuppliers().then(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  async function GetSuppliers() {
    try {
      const suppliers = await api.get(`suppliers`);
      setSuppliers(suppliers.data.suppliers);
    }
    catch (error) {
      console.error(error);
    }

  }

  function ClosePopupUseSupplier() {
    setSupplierToAddToSupplierList(null);
  }

  async function ToggleSupplierToSuppliersList() {
    setAddingSupplierToSuppliersList(true);
    await (supplierToAddToSupplierList.using ? RemoveSupplierToSuppliersList() : AddSupplierToSuppliersList());
    await GetSuppliers();
    setAddingSupplierToSuppliersList(false);
    setSupplierToAddToSupplierList(null);
  }

  async function AddSupplierToSuppliersList() {
    try {
      const suppliers = await api.post(`suppliers/useSupplier`, { supplierId: supplierToAddToSupplierList.supplierId });

      if (!suppliers.data.success) {
        setErrorMessage("Não foi possível adicionar fornecedor!");
        return;
      }
    }
    catch (error) {
      setErrorMessage(error?.response?.data?.message || "Não foi possível adicionar fornecedor!");
      console.error(error);
    }
  }

  async function RemoveSupplierToSuppliersList() {
    try {
      const suppliers = await api.post(`suppliers/stopUsingSupplier`, { supplierId: supplierToAddToSupplierList.supplierId });

      if (!suppliers.data.success) {
        setErrorMessage("Não foi possível adicionar fornecedor!");
        return;
      }
    }
    catch (error) {
      setErrorMessage(error?.response?.data?.message || "Não foi possível adicionar fornecedor!");
      console.error(error);
    }
  }

  function GetWarningText() {
    if (supplierToAddToSupplierList?.using)
      return `Você irá remover "${supplierToAddToSupplierList?.name}" da sua lista de fornecedores.`;
    else
      return `Você irá adicionar "${supplierToAddToSupplierList?.name}" na sua lista de fornecedores.`
  }

  return (
    <Style>
      <PageTitle title="Fornecedores" />
      <TwoButtonsModal
        show={supplierToAddToSupplierList?.supplierId != null}
        onHide={ClosePopupUseSupplier}
        loading={addingSupplierToSuppliersList}
        title={supplierToAddToSupplierList?.using ? "Remover fornecedor?" : "Adicionar fornecedor?"}
        body={GetWarningText()}
        secondaryText="Fechar"
        secondaryOnClick={ClosePopupUseSupplier}
        secondaryDisabled={addingSupplierToSuppliersList}
        primaryText="Confirmar"
        primaryOnClick={ToggleSupplierToSuppliersList}
        primaryDisabled={addingSupplierToSuppliersList}
      />
      {errorMessage && <h1 className="alert"> {errorMessage}</h1>}
      <Spinner spinning={loading} />

      <section className="table-title">
        <h1>Fornecedores</h1>
      </section>
      <table className="table table-striped table-bordered table-hover">
        <thead >
          <tr>
            <th>Logo</th>
            <th>Fornecedor</th>
            <th>Usando fornecedor</th>
          </tr>
        </thead>
        <tbody>
          {suppliers && suppliers.length > 0 && suppliers.map(supplier => {
            return (
              <tr key={supplier.supplierId} className="clickable" onClick={() => setSupplierToAddToSupplierList(supplier)}>
                <td id="logo"><img src={supplier.logoUrl} alt={`Logo da ${supplier.name}`} /></td>
                <td>{supplier.name}</td>
                <td id="usingSupplier" >
                  {supplier.using ?
                    <div className="action">
                      <FaRegCheckCircle className="icon" />
                    </div> :
                    <div className="action">
                      <FaRegCircle className="icon" />
                    </div>}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Style>

  )
}